import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import { routerReducer } from '../store';
import accessCards from './accessCards';
import accessPoints from './accessPoints';
import accessPointsDeviceModels from './accessPointsDeviceModels';
import admins from './admins';
import allAccessPoints from './allAccessPoints';
import amenity from './amenity';
import announcements from './announcements';
import auth from './auth';
import branchData from './branchData';
import buildingGuide from './buildingGuide';
import buildings from './buildings';
import buildingsList from './buildingsList';
import calendar from './calendar';
import callCenter from './callCenter';
import callCenterAgents from './callCenterAgents';
import cameras from './cameras';
import carsonActivity from './carsonActivity';
import chart from './chart';
import common from './common';
import community from './community';
import createThread from './createThread';
import currentUserNotifications from './currentUserNotifications';
import dashboard from './dashboard';
import deliveries from './deliveries';
import deliveryType from './deliveryType';
import documentLibrary from './documentLibrary';
import doors from './doors';
import eagleEye from './eagleEye';
import events from './events';
import externalAccounts from './externalAccounts';
import frontDesk from './frontDesk';
import getRecipients from './getRecipients';
import getRoles from './getRoles';
import homeFeed from './homeFeed';
import ipManagement from './ipManagement';
import leasing from './leasing';
import lists from './lists';
import messages from './messages';
import modal from './modal';
import monthlyBill from './monthlyBill';
import newChatData from './newChatData';
import notificationPreferences from './notificationPreferences';
import notifications from './notifications';
import people from './people';
import person from './person';
import personActivity from './personActivity';
import personNotifications from './personNotifications';
import pmcs from './pmcs';
import pmcsList from './pmcsList';
import popUp from './popUp';
import remoteDoorman from './remoteDoorman';
import remoteDoormanNotifications from './remoteDoormanNotifications';
import selectExisting from './selectExisting';
import serviceRequests from './serviceRequests';
import srCategories from './srCategories';
import staffLog from './staffLog';
import statistics from './statistics';
import todayCount from './todayCount';
import unitActivity from './unitActivity';
import units from './units';
import usersCount from './usersCount';
import visitorKeys from './visitorKeys';
import visitorKeysBuildings from './visitorKeysBuilding';
import visitorLog from './visitorLog';
import visitors from './visitors';
import yourWellbeing from './yourWellbeing';

export default () =>
  combineReducers({
    router: routerReducer,
    allAccessPoints,
    accessPoints,
    buildingGuide,
    carsonActivity,
    doors,
    branchData,
    admins,
    auth,
    buildings,
    callCenter,
    cameras,
    common,
    dashboard,
    deliveries,
    eagleEye,
    events,
    form: formReducer,
    lists,
    modal,
    pmcs,
    pmcsList,
    ipManagement,
    people,
    selectExisting,
    serviceRequests,
    srCategories,
    notifications,
    units,
    visitors,
    visitorLog,
    visitorKeys,
    visitorKeysBuildings,
    messages,
    getRecipients,
    createThread,
    newChatData,
    getRoles,
    notificationPreferences,
    documentLibrary,
    externalAccounts,
    buildingsList,
    person,
    usersCount,
    todayCount,
    accessCards,
    statistics,
    personActivity,
    deliveryType,
    amenity,
    chart,
    currentUserNotifications,
    leasing,
    unitActivity,
    calendar,
    monthlyBill,
    announcements,
    community,
    remoteDoorman,
    callCenterAgents,
    accessPointsDeviceModels,
    frontDesk,
    popUp,
    personNotifications,
    remoteDoormanNotifications,
    staffLog,
    homeFeed,
    yourWellbeing,
  });
